import * as BABYLON from "@babylonjs/core/Legacy/legacy";
import { GameScene } from "./scene";

const log = console.log.bind(console);

export class Asset {
	gameScene: GameScene;

	textureReadyMap: Map<string, boolean>;
	textureMap: Map<string, BABYLON.Texture>;

	meshReadyMap: Map<string, boolean>;
	meshMap: Map<string, BABYLON.ISceneLoaderAsyncResult>;

	bufferReadyMap: Map<string, boolean>;
	bufferMap: Map<string, ArrayBuffer>;

	constructor(gameScene: GameScene) {
		this.gameScene = gameScene;

		this.textureReadyMap = new Map<string, boolean>();
		this.textureMap = new Map<string, BABYLON.Texture>();

		this.meshReadyMap = new Map<string, boolean>();
		this.meshMap = new Map<string, BABYLON.ISceneLoaderAsyncResult>();

		this.bufferReadyMap = new Map<string, boolean>();
		this.bufferMap = new Map<string, ArrayBuffer>();
	}

	copyResoucesFrom(other: Asset) {
		this.textureMap = other.textureMap;
		this.textureReadyMap = other.textureReadyMap;
		this.meshReadyMap = other.meshReadyMap;
		this.meshMap = other.meshMap;
		this.bufferMap = other.bufferMap;
		this.bufferReadyMap = other.bufferReadyMap;
	}

	isLoaded(): boolean {
		for (const [key, value] of this.textureReadyMap) {
			if (!value) {
				return false;
			}
		}
		for (const [key, value] of this.meshReadyMap) {
			if (!value) {
				return false;
			}
		}
		return true;
	}

	loadTexture(url: string, noMipmapOrOptions?: boolean, invertY?: boolean): BABYLON.Texture {
		if (this.textureMap.get(url) !== undefined) {
			return this.textureMap.get(url);
		}

		if (noMipmapOrOptions === undefined) {
			noMipmapOrOptions = null;
		}
		if (invertY === undefined) {
			invertY = undefined;
		}

		let self = this;
		this.textureReadyMap.set(url, false);
		const onLoad = function () {
			self.textureReadyMap.set(url, true);
			self.gameScene.tryStart();
		};
		let tex = new BABYLON.Texture(
			url,
			self.gameScene.bbScene,
			noMipmapOrOptions,
			invertY,
			BABYLON.Texture.TRILINEAR_SAMPLINGMODE,
			onLoad,
		);
		this.textureMap.set(url, tex);
		return tex;
	}

	// 将文件的内容已 buffer 的形式缓存, 用在后面 ImportMeshAsync 中
	// 缓存 buffer 而不是缓存 model 的原因是 model 和 scene 有绑定
	// 切换成新的 scene model 会显示不出来
	loadFileAsync(url: string, cb: (buf: ArrayBuffer) => void, useArrayBuffer?: true) {
		if (this.bufferReadyMap.get(url) === true) {
			let buf = this.bufferMap.get(url);
			cb(buf);
			return;
		}

		this.bufferReadyMap.set(url, false);

		let self = this;
		BABYLON.Tools.LoadFileAsync(url, useArrayBuffer).then((buf: ArrayBuffer) => {
			self.bufferReadyMap.set(url, true);
			self.bufferMap.set(url, buf);
			cb(buf);
		});
	}

	GetMesh(rootUrl: string, sceneFilename: string | File | ArrayBufferView): BABYLON.ISceneLoaderAsyncResult {
		return this.meshMap[rootUrl + sceneFilename];
	}

	loadMeshAsync(
		meshNames: any,
		rootUrl: string,
		sceneFilename: string | File | ArrayBufferView,
		scene: BABYLON.Nullable<BABYLON.Scene>,
		onSuccess: BABYLON.Nullable<(event: BABYLON.ISceneLoaderAsyncResult) => void>,
		pluginExtension?: BABYLON.Nullable<string>,
	): void {
		let self = this;
		let key = rootUrl + sceneFilename;

		// 用旧 mesh 会绑定旧 scene, 显示不了
		// if (this.meshReadyMap.get(key)) {
		// 	log("meshMap", this.meshMap.get(key));
		// 	onSuccess(this.meshMap.get(key));
		// 	log("asset_tryStart", self.gameScene.createTime);
		// 	self.gameScene.tryStart();
		// 	return;
		// }

		this.meshReadyMap.set(key, false);
		BABYLON.SceneLoader.ImportMeshAsync(meshNames, rootUrl, sceneFilename, scene, undefined, pluginExtension).then(
			(result: BABYLON.ISceneLoaderAsyncResult) => {
				onSuccess(result);

				// 尝试开始游戏
				self.meshReadyMap.set(key, true);
				self.meshMap.set(key, result);
				self.gameScene.tryStart();
			},
		);
	}
}
